import { QUERY_KEYS } from "@/libraries/constant";
import type { ContactDirectoryScope } from "@/libraries/constant";
import {
	getGroupQueryOptions,
	getMembersQueryOptions,
	getTeamQueryOptions,
	getTeamsQueryOptions,
} from "@/queries";
import { onlineManager } from "@tanstack/react-query";
import type { RouteContext } from "@tanstack/react-router";

interface GetContactTeamsLoaderParams {
	directory: boolean;
	scope: ContactDirectoryScope;
}

export function getContactTeamsLoader(
	ctx: RouteContext,
	params: GetContactTeamsLoaderParams,
) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return [
			ctx.queryClient.ensureInfiniteQueryData(
				getMembersQueryOptions({
					directory: params.directory,
				}),
			),
			ctx.queryClient.ensureInfiniteQueryData(getTeamsQueryOptions(params)),
		];
	}
	return [
		ctx.queryClient.getQueryData([QUERY_KEYS.GET_MEMBERS, params]),
		ctx.queryClient.getQueryData([QUERY_KEYS.GET_TEAMS, params]),
	];
}

export function getContactTeamLoader(ctx: RouteContext, id: any) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureQueryData(getTeamQueryOptions(id));
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_TEAM, id]);
}

export function getContactGroupLoader(ctx: RouteContext, id: any) {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureQueryData(getGroupQueryOptions(id));
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_GROUP, id]);
}
